module.exports = __webpack_public_path__ + "img/send-money.dd9ff8e6.svg";